export const getNativeItem = key =>
  new Promise((resolve, reject) => window.NativeStorage.getItem(key, resolve, reject));

export const setNativeItem = (key, value) =>
  new Promise((resolve, reject) => window.NativeStorage.setItem(key, value, resolve, reject));

export const getItem = async function (key) {
  let retval;
  try {
    retval = JSON.parse(await getNativeItem(key));
  } catch (e) {
    if (e.code == 2) {
      retval = null;
    }
  }
  return retval;
}

export const setItem = async function (key, value) {
  return await setNativeItem(key, JSON.stringify(value));
}
